import html2Canvas from 'html2canvas'
import jsPDF from 'jspdf'
import _global from './global.vue';
import 'jspdf-autotable'
import (/* webpackChunkName: "STXIHEI-normal"*/ '../assets/fonts/STXIHEI-normal.js')


export default{
  install (Vue, options) {
    Vue.prototype.getPdfCross = async function (clientName,clientLogoImage,hasNanjing,hasWuhan,hasShenzhen,hasChongqing,summaryTableoverall,campaignDuration,tableData,CPM,MediaCost,gender,age,spend_power, interest,poi,media_type,tableDataCommercial,reference_id,createdBy,team,ifShowViewed,adjusted_CPM,poi_ba_label_selection_list,totalNearbyBusNumber) {
      // Create new PDF file

      let PDF = new jsPDF('', 'pt', 'a4')
      let title = 'JCDecaux Bus Media Solution_' 
      PDF.addFont('STXIHEI-normal.ttf', 'STXIHEI', 'normal');
      PDF.setFont('STXIHEI');

      var picSrc = ''
      if (_global.serverSrc == 'http://127.0.0.1:8000/api'){
        //picSrc = '/frontend/img/'
        picSrc = '/static/img/'
      }
      else{
        picSrc = '/img/'
      }
      
      
      // Add cover page
      let leftMargin = 65.205/2
      let rightMargin = leftMargin
      let a4Width = 595.28
      let a4Height = 841.89

      let BusLogo = new Image()
      let BusLogoUrl = _global.serverSrc.slice(0,-4) + picSrc+ 'logo_cn.png';
      //JcdLogo.src = require('../assets/jcd_logo.png')
      BusLogo.src = BusLogoUrl
      PDF.addImage(BusLogo,'png',a4Width/2-50.5,30,101,49)

      let BamLogo = new Image()
      let BamLogoUrl = _global.serverSrc.slice(0,-4) + picSrc + 'bam_logo.png';
      //JcdLogo.src = require('../assets/jcd_logo.png')
      BamLogo.src = BamLogoUrl
      PDF.addImage(BamLogo,'png',a4Width/2-134.75,a4Height/2-57.5-30,269.5,115)


      if (clientLogoImage !=''){
      PDF.addImage(clientLogoImage,'png',274.25,595.28,46.775,35.44)
      }
      PDF.setFontSize(20);
      PDF.text(clientName,a4Width/2,680.4,'center')

      //Add Date
      let reportDate = new Date()
      let monthsList = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      let reportDate_output = monthsList[reportDate.getMonth()].toString()+ ' ' +reportDate.getDate().toString()+' '+reportDate.getFullYear().toString()
      let reportDate_output_YYMMDD = reportDate.getFullYear()+'/'+(Number(reportDate.getMonth())+1).toString()+'/'+reportDate.getDate()

      PDF.setFontSize(14);
      PDF.setFontType("normal");
      PDF.text(reportDate_output_YYMMDD,a4Width/2,a4Height-30,'center')
      
      
      //Report Info Page
      PDF.addPage()
      PDF.addImage(BusLogo,'png',leftMargin,30,101/2,49/2)
      PDF.addImage(BamLogo,'png',a4Width-rightMargin-67.375,30,269.5/4,115/4)

      PDF.setFont('STXIHEI');
      PDF.setFontSize(20);
      PDF.text('巴士媒体受众曝光测量系统',a4Width/2,99.225-20,'center')
      PDF.setFontSize(14);
      PDF.setFont('Helvetica')
      PDF.text('Bus Media Solution - Audience Impressions Based',a4Width/2,99.225+10,'center')


      let chosen_city = '';
      if(hasNanjing == true) {
        chosen_city ='Nanjing '
      } 
      if (hasWuhan == true) {
        chosen_city =chosen_city +'Wuhan '
        
      }
      if (hasShenzhen == true) {
        chosen_city = chosen_city + 'Shenzhen '
      }
      if (hasChongqing == true) {
        chosen_city = chosen_city + 'Chongqing'
      }

      let infoTable_overall = [
       
        ['方案名称 / Name of proposal:'+clientName,'发布城市 / City: '+chosen_city],
        ['巴士线路数量 / No. of bus lines: '+summaryTableoverall[summaryTableoverall.length - 1].line_qty,"巴士台数 / Bus Q'ty: "+summaryTableoverall[summaryTableoverall.length - 1].body_qty],
        ['广告有效展示次数 / Viewed Impressions:'+summaryTableoverall[summaryTableoverall.length -1].impression.toLocaleString(),'媒体刊例费总价 / Total Media Cost ￥: '+ summaryTableoverall[summaryTableoverall.length - 1].price.toLocaleString()],
        ['千次展示成本 / CPM: '+summaryTableoverall[summaryTableoverall.length -1].cpm.toLocaleString(),'报告时间 / Report Date: '+reportDate_output_YYMMDD]
      ]

      PDF.autoTable({
        body: infoTable_overall,
          styles: { font: "STXIHEI"} ,
          tableWidth: 'auto',
          startY: 123.575+6,
      }
      )
      
      if(summaryTableoverall[summaryTableoverall.length -1].impression == summaryTableoverall[summaryTableoverall.length -1].impression_cluster && summaryTableoverall[summaryTableoverall.length -1].cpm == summaryTableoverall[summaryTableoverall.length -1].cpm_cluster){
        PDF.autoTable({
          head:[['广告有效展示次数 / Audience Impressions','千次展示成本 / CPM ￥']],
          body: [
            [summaryTableoverall[summaryTableoverall.length -1].impression.toLocaleString(),summaryTableoverall[summaryTableoverall.length -1].cpm.toLocaleString()],
          ],
            headStyles:{fontStyle:'noraml',fontSize:8},
            styles: { font: "STXIHEI",fontSize:14} ,
            tableWidth: 'auto',
            startY: 245.15+15-5,
            columnStyles: {
              1: {cellWidth:267}
            }
        }
        )
      } else {
        PDF.autoTable({
          head:[['广告有效展示次数 / Audience Impressions','千次展示成本 / CPM ￥']],
          body: [
            [summaryTableoverall[summaryTableoverall.length -1].impression.toLocaleString(),summaryTableoverall[summaryTableoverall.length -1].cpm.toLocaleString()],
          ],
            headStyles:{fontStyle:'noraml',fontSize:8},
            styles: { font: "STXIHEI",fontSize:14} ,
            tableWidth: 'auto',
            startY: 245.15+15-5,
            columnStyles: {
              1: {cellWidth:267}
            }
        }
        )
        PDF.autoTable({
          head:[['广告有效展示次数（基于目标受众） \nViewed Impressions (Target Audience Based)','千次展示成本（基于目标受众）\nCPM (Target Audience Based) ￥']],
          body: [
            [summaryTableoverall[summaryTableoverall.length -1].impression_cluster.toLocaleString(),summaryTableoverall[summaryTableoverall.length -1].cpm_cluster.toLocaleString()],
          ],
            headStyles:{fontStyle:'noraml',fontSize:8},
            styles: { font: "STXIHEI",fontSize:14} ,
            tableWidth: 'auto',
            startY: 295.15+15-5,
            columnStyles: {
              1: {cellWidth:267}
            }
        }
        )
      }


      await html2Canvas(document.querySelector('#overall_map'),{
        scrollX: 0,
        //避免页面上方空白
        scrollY: -window.scrollY,
        taintTest : false,
            allowTaint: false,
            useCORS: true,
        scale: 2,

      }).then(function(canvas){
        PDF.setPage(2)
        let contentWidthMap = 510
        let contentHeightMap = 430
        let mapPage = canvas.toDataURL('image/jpeg', 1)
        PDF.addImage(mapPage, 'JPEG', 40,370,  contentWidthMap, contentHeightMap,'','',0)// rotation 270 degrees
        
      })
      if(hasNanjing == true){
        PDF.addPage()
        PDF.addImage(BusLogo,'png',leftMargin,30,101/2,49/2)
        PDF.addImage(BamLogo,'png',a4Width-rightMargin-67.375,30,269.5/4,115/4)
        PDF.setFont('Helvetica')
        PDF.setFontSize(14);
        PDF.text('Bus Media Solution - Audience Impressions Based',a4Width/2,99.225+10,'center')
        PDF.setFont('STXIHEI');
        PDF.setFontSize(20);
        PDF.text('巴士媒体受众曝光测量系统',a4Width/2,99.225-20,'center')

        let table_Nanjing = [
            ['发布城市 / City: '+'Nanjing','报告时间 / Report Date: '+reportDate_output_YYMMDD],
            ['计划发布日期 / Campaign Start:'+summaryTableoverall[0].date,'发布时长（月）/ Duration(month):'+summaryTableoverall[0].duration],
            ['巴士线路数量 / No. of bus lines: '+summaryTableoverall[0].line_qty,"巴士台数 / Bus Q'ty: "+summaryTableoverall[0].body_qty],
            ['媒体刊例费总价 / Total Media Cost ￥: '+ summaryTableoverall[0].price.toLocaleString(),'媒体形式 / Media Format:'+summaryTableoverall[0].data_media],
        ]
        PDF.autoTable({
            body: table_Nanjing,
              styles: { font: "STXIHEI"} ,
              tableWidth: 'auto',
              startY: 123.575+6,
          }
          )
        let startY_audience =  360.735-16
        if(summaryTableoverall[0].impression == summaryTableoverall[0].impression_cluster && summaryTableoverall[0].cpm == summaryTableoverall[0].cpm_cluster){
          PDF.autoTable({
            head:[['广告有效展示次数 / Audience Impressions','千次展示成本 / CPM ￥']],
            body: [
              [summaryTableoverall[0].impression.toLocaleString(),summaryTableoverall[0].cpm.toLocaleString()],
            ],
            headStyles:{fontStyle:'noraml',fontSize:8},
            styles: { font: "STXIHEI",fontSize:14} ,
            tableWidth: 'auto',
            startY: 225.15+15-5,
            columnStyles: {
                1: {cellWidth:267}
              }
          }
        )
        } else {
          startY_audience = 360.735
          PDF.autoTable({
            head:[['广告有效展示次数 / Audience Impressions','千次展示成本 / CPM ￥']],
            body: [
              [summaryTableoverall[0].impression.toLocaleString(),summaryTableoverall[0].cpm.toLocaleString()],
            ],
            headStyles:{fontStyle:'noraml',fontSize:8},
            styles: { font: "STXIHEI",fontSize:14} ,
            tableWidth: 'auto',
            startY: 215.15+15-5,
            columnStyles: {
                1: {cellWidth:267}
              }
          }
        )
        PDF.autoTable({
          head:[['广告有效展示次数（基于目标受众） \nViewed Impressions (Target Audience Based)','千次展示成本（基于目标受众）\nCPM (Target Audience Based) ￥']],
          body: [
            [summaryTableoverall[0].impression_cluster.toLocaleString(),summaryTableoverall[0].cpm_cluster.toLocaleString()],
          ],
          headStyles:{fontStyle:'noraml',fontSize:8},
          styles: { font: "STXIHEI",fontSize:14} ,
          tableWidth: 'auto',
          startY: 260.15+15-5,
          columnStyles: {
              1: {cellWidth:267}
            }
        }
      )
        }
        
        PDF.setFont('STXIHEI');
        PDF.setFontSize(10);
        PDF.text('受众特征 Audience Criterias: ',leftMargin+7,315+21)
        PDF.autoTable({
            body: [
              ['性别 / Gender: '+summaryTableoverall[0].data_audience.value_gender,'年龄 / Age: '+summaryTableoverall[0].data_audience.value_age],
              ['消费能力 / Spend Power: '+summaryTableoverall[0].data_audience.value_spend_power,"兴趣 / Interest: "+summaryTableoverall[0].data_audience.value_interest],
              ['目标兴趣点 / Target POI: '+summaryTableoverall[0].data_poi,'途径地点 / Nearby Location:'+summaryTableoverall[0].data_poi_ba_label_selection_list]
            ],
            styles: { font: "STXIHEI",fontSize:8,} ,
            tableWidth:  'auto',
            startY: startY_audience,
            columnStyles: {
              1: {cellWidth:267}
            }  
         }
        )
      await html2Canvas(document.querySelector('#barchart_impression_Nanjing'),{
        scrollX: 0,
        //避免页面上方空白
        scrollY: -window.scrollY,
        allowTaint: true,
        scale: 2,

      }).then(function(canvas){
        PDF.setPage(3)
        let startLocationChartCpm = 440
        let contentWidthChartCpm = (a4Width - leftMargin - rightMargin)/2
        let contentHeightChartCpm = 141.75
        let infoPageData = canvas.toDataURL('image/jpeg', 1)
        PDF.addImage(infoPageData, 'JPEG', leftMargin, startLocationChartCpm,  contentWidthChartCpm, contentHeightChartCpm)
      })
      await html2Canvas(document.querySelector('#barchart_cpm_Nanjing'),{
        scrollX: 0,
        //避免页面上方空白
        scrollY: -window.scrollY,
        allowTaint: true,
        scale: 2,

      }).then(function(canvas){
        PDF.setPage(3)
        let startLocationChartCpm = 440
        let contentWidthChartCpm = (a4Width - leftMargin - rightMargin)/2
        let contentHeightChartCpm = 141.75
        let infoPageData = canvas.toDataURL('image/jpeg', 1)
        PDF.addImage(infoPageData, 'JPEG',  a4Width/2, startLocationChartCpm, contentWidthChartCpm, contentHeightChartCpm)
      })
      await html2Canvas(document.querySelector('#chart_index_Nanjing'),{
        scrollX: 0,
        //避免页面上方空白
        scrollY: -window.scrollY,
        allowTaint: true,
        scale: 2,

      }).then(function(canvas){
        PDF.setPage(3)
        let startLocationChartIndex = 630
        let contentWidthChartIndex  = (a4Width - leftMargin - rightMargin)/2
        let contentHeightChartIndex  = 60

        let infoPageData = canvas.toDataURL('image/jpeg', 1)
        PDF.addImage(infoPageData, 'JPEG', leftMargin, startLocationChartIndex,  contentWidthChartIndex , contentHeightChartIndex )

      })
      await html2Canvas(document.querySelector('#chart_rank_Nanjing'),{
        scrollX: 0,
        //避免页面上方空白
        scrollY: -window.scrollY,
        allowTaint: true,
        scale: 2,

      }).then(function(canvas){
        PDF.setPage(3)
        let startLocationChartIndex = 630
        let contentWidthChartIndex  = (a4Width - leftMargin - rightMargin)/2
        let contentHeightChartIndex  = 60

        let infoPageData = canvas.toDataURL('image/jpeg', 1)
        PDF.addImage(infoPageData, 'JPEG', a4Width/2, startLocationChartIndex,  contentWidthChartIndex , contentHeightChartIndex )

      })
      PDF.addPage()
      let tableDataCommercialExport = new Array() 
      summaryTableoverall[0].bus_line.forEach((item, index) => {
        tableDataCommercialExport[index] = new Array()
        tableDataCommercialExport[index][0] = item['bus_id']
        tableDataCommercialExport[index][1] = item['rank']
        tableDataCommercialExport[index][2] = item['media_type_label']
        tableDataCommercialExport[index][3] = item['bus_quantity']
        tableDataCommercialExport[index][4] = item['duration']
        tableDataCommercialExport[index][5] = item['rate_card']
        tableDataCommercialExport[index][6] = item['price']
        tableDataCommercialExport[index][7] = item['impression_total']
        tableDataCommercialExport[index][8] = item['adjusted_impression']
        tableDataCommercialExport[index][9] = item['CPM']
        tableDataCommercialExport[index][10] = item['adjusted_CPM']
      })

      PDF.autoTable({
        head:[['巴士线路\nLine','线路级别\nGrade\n(Legacy)','媒体形式\nMedia \nFormat','巴士台数\nBus\nQuantity','发布时长\n（月）\nDuration\n(Month)','媒体\n刊例费\n/月/台￥\nMedia Cost\n/Mth/Unit￥','媒体\n刊例费\n总价￥\nTotal\nMedia Cost￥','广告有效\n展示次数\nViewed\nImpressions','广告有效\n展示次数\n(基于目标受众)\nViewed\nImpressions\n(Target Audience \nBased)','千次展示\n成本\nCPM￥','千次展示\n成本\n(基于目标受众)\nCPM￥\n(Target Audience \nBased)']],
        body: tableDataCommercialExport,
        headStyles:{fontStyle:'noraml',fontSize:8},
        columnStyles: {
            0: {halign:'left'},
            1: {halign:'center'},
        },
        styles: { font: "STXIHEI",halign:'right',fontSize:8} ,
        margin: {left:rightMargin,right:rightMargin}, //  let leftMargin = 65.205/2
        tableWidth: 'auto',
        }
      )
      
      //Bus Mape Page 
      await html2Canvas(document.querySelector('#map_Nanjing'),{
        scrollX: 0,
        //避免页面上方空白
        scrollY: -window.scrollY,
        taintTest : false,
        allowTaint: false,
        useCORS: true,//允许跨域
        scale: 3,
      }).then(function(canvas){
        PDF.addPage()
        PDF.setFont('STXIHEI');
        PDF.setFontSize(15);
        PDF.text('地图参考页 Map Reference: ',550,30,'',270)

        PDF.setFontSize(6);
        PDF.text('途径地点包括单个POI和商圈\nPOI是地图上单独的点位\n商圈是多个POI的集合',500,30,'',270)
        PDF.text('Nearby Location includes POI and Business Area\nPOI is the single point\nBusiness Area is the assemble of serval POIs',465,30,'',270)

        let contentWidthMap = 510
        let contentHeightMap = 430
        let mapPage = canvas.toDataURL('image/jpeg', 1)
        PDF.addImage(mapPage, 'JPEG', 60,-220,  contentWidthMap, contentHeightMap,'','',270)// rotation 270 degrees
      })

  
      }
      if(hasWuhan) {
        PDF.addPage()
        PDF.addImage(BusLogo,'png',leftMargin,30,101/2,49/2)
        PDF.addImage(BamLogo,'png',a4Width-rightMargin-67.375,30,269.5/4,115/4)
        PDF.setFont('Helvetica')
        PDF.setFontSize(14);
        PDF.text('Bus Media Solution - Audience Impressions Based',a4Width/2,99.225+10,'center')
        PDF.setFont('STXIHEI');
        PDF.setFontSize(20);
        PDF.text('巴士媒体受众曝光测量系统',a4Width/2,99.225-20,'center')

        let table_Nanjing = [
            ['发布城市 / City: '+'Wuhan','报告时间 / Report Date: '+reportDate_output_YYMMDD],
            ['计划发布日期 / Campaign Start:'+summaryTableoverall[1].date,'发布时长（月）/ Duration(month):'+summaryTableoverall[1].duration],
            ['巴士线路数量 / No. of bus lines: '+summaryTableoverall[1].line_qty,"巴士台数 / Bus Q'ty: "+summaryTableoverall[1].body_qty],
            ['媒体刊例费总价 / Total Media Cost ￥: '+ summaryTableoverall[1].price.toLocaleString(),'媒体形式 / Media Format:'+summaryTableoverall[1].data_media],
        ]
        PDF.autoTable({
            body: table_Nanjing,
              styles: { font: "STXIHEI"} ,
              tableWidth: 'auto',
              startY: 123.575+6,
          }
          )
        let startY_audience =  360.735-16
        if(summaryTableoverall[1].impression == summaryTableoverall[1].impression_cluster && summaryTableoverall[1].cpm == summaryTableoverall[1].cpm_cluster){
          PDF.autoTable({
            head:[['广告有效展示次数 / Audience Impressions','千次展示成本 / CPM ￥']],
            body: [
              [summaryTableoverall[1].impression.toLocaleString(),summaryTableoverall[1].cpm.toLocaleString()],
            ],
              headStyles:{fontStyle:'noraml',fontSize:8},
              styles: { font: "STXIHEI",fontSize:14} ,
              tableWidth: 'auto',
              startY: 225.15+15-5,
              columnStyles: {
                1: {cellWidth:267}
              }
          }
          )
        } else {
          startY_audience =  360.735
          PDF.autoTable({
            head:[['广告有效展示次数 / Audience Impressions','千次展示成本 / CPM ￥']],
            body: [
              [summaryTableoverall[1].impression.toLocaleString(),summaryTableoverall[1].cpm.toLocaleString()],
            ],
              headStyles:{fontStyle:'noraml',fontSize:8},
              styles: { font: "STXIHEI",fontSize:14} ,
              tableWidth: 'auto',
              startY: 215.15+15-5,
              columnStyles: {
                1: {cellWidth:267}
              }
          }
          )
          PDF.autoTable({
            head:[['广告有效展示次数（基于目标受众） \nViewed Impressions (Target Audience Based)','千次展示成本（基于目标受众）\nCPM (Target Audience Based) ￥']],
            body: [
              [summaryTableoverall[1].impression_cluster.toLocaleString(),summaryTableoverall[1].cpm_cluster.toLocaleString()],
            ],
              headStyles:{fontStyle:'noraml',fontSize:8},
              styles: { font: "STXIHEI",fontSize:14} ,
              tableWidth: 'auto',
              startY: 260.15+15-5,
              columnStyles: {
                1: {cellWidth:267}
              }
          }
          )
        }
        
          PDF.setFont('STXIHEI');
          PDF.setFontSize(10);
          PDF.text('受众特征 Audience Criterias: ',leftMargin+7,315+21)
          PDF.autoTable({
            body: [
                ['性别 / Gender: '+summaryTableoverall[1].data_audience.value_gender,'年龄 / Age: '+summaryTableoverall[1].data_audience.value_age],
                ['消费能力 / Spend Power: '+summaryTableoverall[1].data_audience.value_spend_power,"兴趣 / Interest: "+summaryTableoverall[1].data_audience.value_interest],
                ['目标兴趣点 / Target POI: '+summaryTableoverall[1].data_poi,'途径地点 / Nearby Location:'+summaryTableoverall[1].data_poi_ba_label_selection_list]
            ],
            styles: { font: "STXIHEI",fontSize:8,} ,
            tableWidth:  'auto',
            startY: startY_audience,
            columnStyles: {
              1: {cellWidth:267}
            }  
          }
          )
          await html2Canvas(document.querySelector('#barchart_impression_Wuhan'),{
            scrollX: 0,
            //避免页面上方空白
            scrollY: -window.scrollY,
            allowTaint: true,
            scale: 2,

          }).then(function(canvas){
            PDF.setPage(PDF.internal.getNumberOfPages())
            let startLocationChartCpm = 440
            let contentWidthChartCpm = (a4Width - leftMargin - rightMargin)/2
            let contentHeightChartCpm = 141.75
            let infoPageData = canvas.toDataURL('image/jpeg', 1)
            PDF.addImage(infoPageData, 'JPEG', leftMargin, startLocationChartCpm, contentWidthChartCpm, contentHeightChartCpm)
          })
          await html2Canvas(document.querySelector('#barchart_cpm_Wuhan'),{
            scrollX: 0,
            //避免页面上方空白
            scrollY: -window.scrollY,
            allowTaint: true,
            scale: 2,

          }).then(function(canvas){
            PDF.setPage(PDF.internal.getNumberOfPages())
            let startLocationChartCpm = 440
            let contentWidthChartCpm = (a4Width - leftMargin - rightMargin)/2
            let contentHeightChartCpm = 141.75
            let infoPageData = canvas.toDataURL('image/jpeg', 1)
            PDF.addImage(infoPageData, 'JPEG', a4Width/2, startLocationChartCpm, contentWidthChartCpm, contentHeightChartCpm)
          })

          await html2Canvas(document.querySelector('#chart_index_Wuhan'),{
            scrollX: 0,
            //避免页面上方空白
            scrollY: -window.scrollY,
            allowTaint: true,
            scale: 2,
    
          }).then(function(canvas){
            PDF.setPage(PDF.internal.getNumberOfPages())
            let startLocationChartIndex = 630
            let contentWidthChartIndex  = (a4Width - leftMargin - rightMargin)/2
            let contentHeightChartIndex  = 60
    
            let infoPageData = canvas.toDataURL('image/jpeg', 1)
            PDF.addImage(infoPageData, 'JPEG', leftMargin, startLocationChartIndex,  contentWidthChartIndex , contentHeightChartIndex )
    
          })
          await html2Canvas(document.querySelector('#chart_rank_Wuhan'),{
            scrollX: 0,
            //避免页面上方空白
            scrollY: -window.scrollY,
            allowTaint: true,
            scale: 2,
    
          }).then(function(canvas){
            PDF.setPage(PDF.internal.getNumberOfPages())
            let startLocationChartIndex = 630
            let contentWidthChartIndex  = (a4Width - leftMargin - rightMargin)/2
            let contentHeightChartIndex  = 60
    
            let infoPageData = canvas.toDataURL('image/jpeg', 1)
            PDF.addImage(infoPageData, 'JPEG', a4Width/2, startLocationChartIndex,  contentWidthChartIndex , contentHeightChartIndex )
    
          })
          PDF.addPage()
          let tableDataCommercialExport = new Array()  
          summaryTableoverall[1].bus_line.forEach((item, index) => {
            tableDataCommercialExport[index] = new Array()
            tableDataCommercialExport[index][0] = item['bus_id']
            tableDataCommercialExport[index][1] = item['rank']
            tableDataCommercialExport[index][2] = item['media_type_label']
            tableDataCommercialExport[index][3] = item['bus_quantity']
            tableDataCommercialExport[index][4] = item['duration']
            tableDataCommercialExport[index][5] = item['rate_card']
            tableDataCommercialExport[index][6] = item['price']
            tableDataCommercialExport[index][7] = item['impression_total']
            tableDataCommercialExport[index][8] = item['adjusted_impression']
            tableDataCommercialExport[index][9] = item['CPM']
            tableDataCommercialExport[index][10] = item['adjusted_CPM']
          })
          PDF.autoTable({
            head:[['巴士线路\nLine','线路级别\nGrade\n(Legacy)','媒体形式\nMedia \nFormat','巴士台数\nBus\nQuantity','发布时长\n（月）\nDuration\n(Month)','媒体\n刊例费\n/月/台￥\nMedia Cost\n/Mth/Unit￥','媒体\n刊例费\n总价￥\nTotal\nMedia Cost￥','广告有效\n展示次数\nViewed\nImpressions','广告有效\n展示次数\n(基于目标受众)\nViewed\nImpressions\n(Target Audience \nBased)','千次展示\n成本\nCPM￥','千次展示\n成本\n(基于目标受众)\nCPM￥\n(Target Audience \nBased)']],
            body: tableDataCommercialExport,
            headStyles:{fontStyle:'noraml',fontSize:8},
              columnStyles: {
                0: {halign:'left'},
                1: {halign:'center'},
              },
            styles: { font: "STXIHEI",halign:'right',fontSize:8} ,
            //theme:'grid',
            margin: {left:rightMargin,right:rightMargin}, //  let leftMargin = 65.205/2
 
            tableWidth: 'auto',
 
            }
          )
   
          //Bus Mape Page 
          await html2Canvas(document.querySelector('#map_Wuhan'),{
            scrollX: 0,
            //避免页面上方空白
            scrollY: -window.scrollY,
            taintTest : false,
            allowTaint: false,
            useCORS: true,//允许跨域
            scale: 3,
          }).then(function(canvas){
            PDF.addPage()
            PDF.setFont('STXIHEI');
            PDF.setFontSize(15);
            PDF.text('地图参考页 Map Reference: ',550,30,'',270)
            PDF.setFontSize(6);
            PDF.text('途径地点包括单个POI和商圈\nPOI是地图上单独的点位\n商圈是多个POI的集合',500,30,'',270)
            PDF.text('Nearby Location includes POI and Business Area\nPOI is the single point\nBusiness Area is the assemble of serval POIs',465,30,'',270)
            let contentWidthMap = 510
            let contentHeightMap = 430
            let mapPage = canvas.toDataURL('image/jpeg', 1)
            PDF.addImage(mapPage, 'JPEG', 60,-220,  contentWidthMap, contentHeightMap,'','',270)// rotation 270 degrees
          })
      }
      if(hasShenzhen) {
        PDF.addPage()
        PDF.addImage(BusLogo,'png',leftMargin,30,101/2,49/2)
        PDF.addImage(BamLogo,'png',a4Width-rightMargin-67.375,30,269.5/4,115/4)
        PDF.setFont('Helvetica')
        PDF.setFontSize(14);
        PDF.text('Bus Media Solution - Audience Impressions Based',a4Width/2,99.225+10,'center')
        PDF.setFont('STXIHEI');
        PDF.setFontSize(20);
        PDF.text('巴士媒体受众曝光测量系统',a4Width/2,99.225-20,'center')

        let table_Nanjing = [
            ['发布城市 / City: '+'Shenzhen','报告时间 / Report Date: '+reportDate_output_YYMMDD],
            ['计划发布日期 / Campaign Start:'+summaryTableoverall[2].date,'发布时长（月）/ Duration(month):'+summaryTableoverall[2].duration],
            ['巴士线路数量 / No. of bus lines: '+summaryTableoverall[2].line_qty,"巴士台数 / Bus Q'ty: "+summaryTableoverall[2].body_qty],
            ['媒体刊例费总价 / Total Media Cost ￥: '+ summaryTableoverall[2].price.toLocaleString(),'媒体形式 / Media Format:'+summaryTableoverall[2].data_media],
        ]
        PDF.autoTable({
            body: table_Nanjing,
              styles: { font: "STXIHEI"} ,
              tableWidth: 'auto',
              startY: 123.575+6,
          }
          )
        let startY_audience =  360.735-16
        if(summaryTableoverall[2].impression == summaryTableoverall[2].impression_cluster && summaryTableoverall[2].cpm == summaryTableoverall[2].cpm_cluster){
          PDF.autoTable({
            head:[['广告有效展示次数 / Audience Impressions','千次展示成本 / CPM ￥']],
            body: [
              [summaryTableoverall[2].impression.toLocaleString(),summaryTableoverall[2].cpm.toLocaleString()],
            ],
              headStyles:{fontStyle:'noraml',fontSize:8},
              styles: { font: "STXIHEI",fontSize:14} ,
              tableWidth: 'auto',
              startY: 225.15+15-5,
              columnStyles: {
                1: {cellWidth:267}
              }
          }
          )
        } else {
          startY_audience =  360.735
          PDF.autoTable({
            head:[['广告有效展示次数 / Audience Impressions','千次展示成本 / CPM ￥']],
            body: [
              [summaryTableoverall[2].impression.toLocaleString(),summaryTableoverall[2].cpm.toLocaleString()],
            ],
              headStyles:{fontStyle:'noraml',fontSize:8},
              styles: { font: "STXIHEI",fontSize:14} ,
              tableWidth: 'auto',
              startY: 215.15+15-5,
              columnStyles: {
                1: {cellWidth:267}
              }
          }
          )
          PDF.autoTable({
            head:[['广告有效展示次数（基于目标受众） \nViewed Impressions (Target Audience Based)','千次展示成本（基于目标受众）\nCPM (Target Audience Based) ￥']],
            body: [
              [summaryTableoverall[2].impression_cluster.toLocaleString(),summaryTableoverall[2].cpm_cluster.toLocaleString()],
            ],
              headStyles:{fontStyle:'noraml',fontSize:8},
              styles: { font: "STXIHEI",fontSize:14} ,
              tableWidth: 'auto',
              startY: 260.15+15-5,
              columnStyles: {
                1: {cellWidth:267}
              }
          }
          )
        }
   
        PDF.setFont('STXIHEI');
        PDF.setFontSize(10);
        PDF.text('受众特征 Audience Criterias: ',leftMargin+7,315+21)
        PDF.autoTable({
          body: [
            ['性别 / Gender: '+summaryTableoverall[2].data_audience.value_gender,'年龄 / Age: '+summaryTableoverall[2].data_audience.value_age],
            ['消费能力 / Spend Power: '+summaryTableoverall[2].data_audience.value_spend_power,"兴趣 / Interest: "+summaryTableoverall[2].data_audience.value_interest],
            ['目标兴趣点 / Target POI: '+summaryTableoverall[2].data_poi,'途径地点 / Nearby Location:'+summaryTableoverall[2].data_poi_ba_label_selection_list]
          ],
          styles: { font: "STXIHEI",fontSize:8,} ,
          tableWidth:  'auto',
          startY: startY_audience,
          columnStyles: {
            1: {cellWidth:267}
          }  
        }
        )
        await html2Canvas(document.querySelector('#barchart_impression_Shenzhen'),{
            scrollX: 0,
            //避免页面上方空白
            scrollY: -window.scrollY,
            allowTaint: true,
            scale: 2,

        }).then(function(canvas){
          PDF.setPage(PDF.internal.getNumberOfPages())

          let startLocationChartCpm = 440
          let contentWidthChartCpm = (a4Width - leftMargin - rightMargin)/2
          let contentHeightChartCpm = 141.75
          let infoPageData = canvas.toDataURL('image/jpeg', 1)
          PDF.addImage(infoPageData, 'JPEG', leftMargin, startLocationChartCpm, contentWidthChartCpm, contentHeightChartCpm)
        })
        await html2Canvas(document.querySelector('#barchart_cpm_Shenzhen'),{
          scrollX: 0,
          //避免页面上方空白
          scrollY: -window.scrollY,
          allowTaint: true,
          scale: 2,

        }).then(function(canvas){
          PDF.setPage(PDF.internal.getNumberOfPages())
          let startLocationChartCpm = 440
          let contentWidthChartCpm = (a4Width - leftMargin - rightMargin)/2
          let contentHeightChartCpm = 141.75
          let infoPageData = canvas.toDataURL('image/jpeg', 1)
          PDF.addImage(infoPageData, 'JPEG', a4Width/2, startLocationChartCpm, contentWidthChartCpm, contentHeightChartCpm)
        })
        await html2Canvas(document.querySelector('#chart_index_Shenzhen'),{
          scrollX: 0,
          //避免页面上方空白
          scrollY: -window.scrollY,
          allowTaint: true,
          scale: 2,
  
        }).then(function(canvas){
          PDF.setPage(PDF.internal.getNumberOfPages())
          let startLocationChartIndex = 630
          let contentWidthChartIndex  = (a4Width - leftMargin - rightMargin)/2
          let contentHeightChartIndex  = 60
  
          let infoPageData = canvas.toDataURL('image/jpeg', 1)
          PDF.addImage(infoPageData, 'JPEG', leftMargin, startLocationChartIndex,  contentWidthChartIndex , contentHeightChartIndex )
  
        })
        await html2Canvas(document.querySelector('#chart_rank_Shenzhen'),{
          scrollX: 0,
          //避免页面上方空白
          scrollY: -window.scrollY,
          allowTaint: true,
          scale: 2,
  
        }).then(function(canvas){
          PDF.setPage(PDF.internal.getNumberOfPages())
          let startLocationChartIndex = 630
          let contentWidthChartIndex  = (a4Width - leftMargin - rightMargin)/2
          let contentHeightChartIndex  = 60
  
          let infoPageData = canvas.toDataURL('image/jpeg', 1)
          PDF.addImage(infoPageData, 'JPEG', a4Width/2, startLocationChartIndex,  contentWidthChartIndex , contentHeightChartIndex )
  
        })
        PDF.addPage()
        let tableDataCommercialExport = new Array()
        summaryTableoverall[2].bus_line.forEach((item, index) => {
          tableDataCommercialExport[index] = new Array()
          tableDataCommercialExport[index][0] = item['bus_id']
          tableDataCommercialExport[index][1] = item['rank']
          tableDataCommercialExport[index][2] = item['media_type_label']
          tableDataCommercialExport[index][3] = item['bus_quantity']
          tableDataCommercialExport[index][4] = item['duration']
          tableDataCommercialExport[index][5] = item['rate_card']
          tableDataCommercialExport[index][6] = item['price']
          tableDataCommercialExport[index][7] = item['impression_total']
          tableDataCommercialExport[index][8] = item['adjusted_impression']
          tableDataCommercialExport[index][9] = item['CPM']
          tableDataCommercialExport[index][10] = item['adjusted_CPM']
        })

        PDF.autoTable({
          head:[['巴士线路\nLine','线路级别\nGrade\n(Legacy)','媒体形式\nMedia \nFormat','巴士台数\nBus\nQuantity','发布时长\n（月）\nDuration\n(Month)','媒体\n刊例费\n/月/台￥\nMedia Cost\n/Mth/Unit￥','媒体\n刊例费\n总价￥\nTotal\nMedia Cost￥','广告有效\n展示次数\nViewed\nImpressions','广告有效\n展示次数\n(基于目标受众)\nViewed\nImpressions\n(Target Audience \nBased)','千次展示\n成本\nCPM￥','千次展示\n成本\n(基于目标受众)\nCPM￥\n(Target Audience \nBased)']],
          body: tableDataCommercialExport,
          headStyles:{fontStyle:'noraml',fontSize:8},
          columnStyles: {
            0: {halign:'left'},
            1: {halign:'center'},
          },
          styles: { font: "STXIHEI",halign:'right',fontSize:8} ,
          //theme:'grid',
          margin: {left:rightMargin,right:rightMargin}, //  let leftMargin = 65.205/2
 
          tableWidth: 'auto',
 
          }
        )
   
        //Bus Mape Page 
        await html2Canvas(document.querySelector('#map_Shenzhen'),{
          scrollX: 0,
          //避免页面上方空白
          scrollY: -window.scrollY,
          taintTest : false,
          allowTaint: false,
          useCORS: true,//允许跨域
          scale: 3,
        }).then(function(canvas){
          PDF.addPage()
          PDF.setFont('STXIHEI');
          PDF.setFontSize(15);
          PDF.text('地图参考页 Map Reference: ',550,30,'',270)

          PDF.setFontSize(6);
          PDF.text('途径地点包括单个POI和商圈\nPOI是地图上单独的点位\n商圈是多个POI的集合',500,30,'',270)
          PDF.text('Nearby Location includes POI and Business Area\nPOI is the single point\nBusiness Area is the assemble of serval POIs',465,30,'',270)

          let contentWidthMap = 510
          let contentHeightMap = 430
          let mapPage = canvas.toDataURL('image/jpeg', 1)
          PDF.addImage(mapPage, 'JPEG', 60,-220,  contentWidthMap, contentHeightMap,'','',270)// rotation 270 degrees
        })
      }
      if(hasChongqing) {
        PDF.addPage()
        PDF.addImage(BusLogo,'png',leftMargin,30,101/2,49/2)
        PDF.addImage(BamLogo,'png',a4Width-rightMargin-67.375,30,269.5/4,115/4)
        PDF.setFont('Helvetica')
        PDF.setFontSize(14);
        PDF.text('Bus Media Solution - Audience Impressions Based',a4Width/2,99.225+10,'center')
        PDF.setFont('STXIHEI');
        PDF.setFontSize(20);
        PDF.text('巴士媒体受众曝光测量系统',a4Width/2,99.225-20,'center')

        let table_Nanjing = [
            ['发布城市 / City: '+'Chongqing','报告时间 / Report Date: '+reportDate_output_YYMMDD],
            ['计划发布日期 / Campaign Start:'+summaryTableoverall[3].date,'发布时长（月）/ Duration(month):'+summaryTableoverall[3].duration],
            ['巴士线路数量 / No. of bus lines: '+summaryTableoverall[3].line_qty,"巴士台数 / Bus Q'ty: "+summaryTableoverall[3].body_qty],
            ['媒体刊例费总价 / Total Media Cost ￥: '+ summaryTableoverall[3].price.toLocaleString(),'媒体形式 / Media Format:'+summaryTableoverall[3].data_media],
        ]
        PDF.autoTable({
            body: table_Nanjing,
              styles: { font: "STXIHEI"} ,
              tableWidth: 'auto',
              startY: 123.575+6,
          }
          )
        let startY_audience =  360.735-16
        if(summaryTableoverall[3].impression == summaryTableoverall[3].impression_cluster && summaryTableoverall[3].cpm == summaryTableoverall[3].cpm_cluster){
          PDF.autoTable({
            head:[['广告有效展示次数 / Audience Impressions','千次展示成本 / CPM ￥']],
            body: [
              [summaryTableoverall[3].impression.toLocaleString(),summaryTableoverall[3].cpm.toLocaleString()],
            ],
              headStyles:{fontStyle:'noraml',fontSize:8},
              styles: { font: "STXIHEI",fontSize:14} ,
              tableWidth: 'auto',
              startY: 225.15+15-5,
              columnStyles: {
                1: {cellWidth:267}
              }
          }
          )
        } else {
          startY_audience =  360.735
          PDF.autoTable({
            head:[['广告有效展示次数 / Audience Impressions','千次展示成本 / CPM ￥']],
            body: [
              [summaryTableoverall[3].impression.toLocaleString(),summaryTableoverall[3].cpm.toLocaleString()],
            ],
              headStyles:{fontStyle:'noraml',fontSize:8},
              styles: { font: "STXIHEI",fontSize:14} ,
              tableWidth: 'auto',
              startY: 215.15+15-5,
              columnStyles: {
                1: {cellWidth:267}
              }
          }
          )
          PDF.autoTable({
            head:[['广告有效展示次数（基于目标受众） \nViewed Impressions (Target Audience Based)','千次展示成本（基于目标受众）\nCPM (Target Audience Based) ￥']],
            body: [
              [summaryTableoverall[3].impression_cluster.toLocaleString(),summaryTableoverall[3].cpm_cluster.toLocaleString()],
            ],
              headStyles:{fontStyle:'noraml',fontSize:8},
              styles: { font: "STXIHEI",fontSize:14} ,
              tableWidth: 'auto',
              startY: 260.15+15-5,
              columnStyles: {
                1: {cellWidth:267}
              }
          }
          )
        }
        
          PDF.setFont('STXIHEI');
          PDF.setFontSize(10);
          PDF.text('受众特征 Audience Criterias: ',leftMargin+7,315+21)
          PDF.autoTable({
              body: [
                    ['性别 / Gender: '+summaryTableoverall[3].data_audience.value_gender,'年龄 / Age: '+summaryTableoverall[3].data_audience.value_age],
                    ['消费能力 / Spend Power: '+summaryTableoverall[3].data_audience.value_spend_power,"兴趣 / Interest: "+summaryTableoverall[3].data_audience.value_interest],
                    ['目标兴趣点 / Target POI: '+summaryTableoverall[3].data_poi,'途径地点 / Nearby Location:'+summaryTableoverall[3].data_poi_ba_label_selection_list]
              ],
              styles: { font: "STXIHEI",fontSize:8,} ,
              tableWidth:  'auto',
              startY: startY_audience,
              columnStyles: {
                1: {cellWidth:267}
              }  
          }
        )
        await html2Canvas(document.querySelector('#barchart_impression_Chongqing'),{
          scrollX: 0,
           //避免页面上方空白
          scrollY: -window.scrollY,
          allowTaint: true,
          scale: 2,

        }).then(function(canvas){
          PDF.setPage(PDF.internal.getNumberOfPages())

          let startLocationChartCpm = 440
          let contentWidthChartCpm = (a4Width - leftMargin - rightMargin)/2
          let contentHeightChartCpm = 141.75
          let infoPageData = canvas.toDataURL('image/jpeg', 1)
          PDF.addImage(infoPageData, 'JPEG', leftMargin, startLocationChartCpm, contentWidthChartCpm, contentHeightChartCpm)
        })
        await html2Canvas(document.querySelector('#barchart_cpm_Chongqing'),{
          scrollX: 0,
          //避免页面上方空白
          scrollY: -window.scrollY,
          allowTaint: true,
          scale: 2,

        }).then(function(canvas){
          PDF.setPage(PDF.internal.getNumberOfPages())

          let startLocationChartCpm = 440
          let contentWidthChartCpm = (a4Width - leftMargin - rightMargin)/2
          let contentHeightChartCpm = 141.75

   
   
          let infoPageData = canvas.toDataURL('image/jpeg', 1)
          PDF.addImage(infoPageData, 'JPEG', a4Width/2, startLocationChartCpm, contentWidthChartCpm, contentHeightChartCpm)
        })
        await html2Canvas(document.querySelector('#chart_index_Chongqing'),{
          scrollX: 0,
          //避免页面上方空白
          scrollY: -window.scrollY,
          allowTaint: true,
          scale: 2,
  
        }).then(function(canvas){
          PDF.setPage(PDF.internal.getNumberOfPages())
          let startLocationChartIndex = 630
          let contentWidthChartIndex  = (a4Width - leftMargin - rightMargin)/2
          let contentHeightChartIndex  = 60
  
          let infoPageData = canvas.toDataURL('image/jpeg', 1)
          PDF.addImage(infoPageData, 'JPEG', leftMargin, startLocationChartIndex,  contentWidthChartIndex , contentHeightChartIndex )
  
        })
        await html2Canvas(document.querySelector('#chart_rank_Chongqing'),{
          scrollX: 0,
          //避免页面上方空白
          scrollY: -window.scrollY,
          allowTaint: true,
          scale: 2,
  
        }).then(function(canvas){
          PDF.setPage(PDF.internal.getNumberOfPages())
          let startLocationChartIndex = 630
          let contentWidthChartIndex  = (a4Width - leftMargin - rightMargin)/2
          let contentHeightChartIndex  = 60
  
          let infoPageData = canvas.toDataURL('image/jpeg', 1)
          PDF.addImage(infoPageData, 'JPEG', a4Width/2, startLocationChartIndex,  contentWidthChartIndex , contentHeightChartIndex )
  
        })
        PDF.addPage()
        let tableDataCommercialExport = new Array()
  
        summaryTableoverall[3].bus_line.forEach((item, index) => {
          tableDataCommercialExport[index] = new Array()
          tableDataCommercialExport[index][0] = item['bus_id']
          tableDataCommercialExport[index][1] = item['rank']
          tableDataCommercialExport[index][2] = item['media_type_label']
          tableDataCommercialExport[index][3] = item['bus_quantity']
          tableDataCommercialExport[index][4] = item['duration']
          tableDataCommercialExport[index][5] = item['rate_card']
          tableDataCommercialExport[index][6] = item['price']
          tableDataCommercialExport[index][7] = item['impression_total']
          tableDataCommercialExport[index][8] = item['adjusted_impression']
          tableDataCommercialExport[index][9] = item['CPM']
          tableDataCommercialExport[index][10] = item['adjusted_CPM']
        })

        PDF.autoTable({
          head:[['巴士线路\nLine','线路级别\nGrade\n(Legacy)','媒体形式\nMedia \nFormat','巴士台数\nBus\nQuantity','发布时长\n（月）\nDuration\n(Month)','媒体\n刊例费\n/月/台￥\nMedia Cost\n/Mth/Unit￥','媒体\n刊例费\n总价￥\nTotal\nMedia Cost￥','广告有效\n展示次数\nViewed\nImpressions','广告有效\n展示次数\n(基于目标受众)\nViewed\nImpressions\n(Target Audience \nBased)','千次展示\n成本\nCPM￥','千次展示\n成本\n(基于目标受众)\nCPM￥\n(Target Audience \nBased)']],
          body: tableDataCommercialExport,
          headStyles:{fontStyle:'noraml',fontSize:8},
          columnStyles: {
            0: {halign:'left'},
            1: {halign:'center'},
          },
          styles: { font: "STXIHEI",halign:'right',fontSize:8} ,
          //theme:'grid',
          margin: {left:rightMargin,right:rightMargin}, //  let leftMargin = 65.205/2
 
          tableWidth: 'auto',
 
          }
        )
   
        //Bus Mape Page 
        await html2Canvas(document.querySelector('#map_Chongqing'),{
          scrollX: 0,
          //避免页面上方空白
          scrollY: -window.scrollY,
          taintTest : false,
          allowTaint: false,
          useCORS: true,//允许跨域
          scale: 3,
        }).then(function(canvas){
          PDF.addPage()
          PDF.setFont('STXIHEI');
          PDF.setFontSize(15);
          PDF.text('地图参考页 Map Reference: ',550,30,'',270)

          PDF.setFontSize(6);
          PDF.text('途径地点包括单个POI和商圈\nPOI是地图上单独的点位\n商圈是多个POI的集合',500,30,'',270)
          PDF.text('Nearby Location includes POI and Business Area\nPOI is the single point\nBusiness Area is the assemble of serval POIs',465,30,'',270)

          let contentWidthMap = 510
          let contentHeightMap = 430
          let mapPage = canvas.toDataURL('image/jpeg', 1)
          PDF.addImage(mapPage, 'JPEG', 60,-220,  contentWidthMap, contentHeightMap,'','',270)// rotation 270 degrees
        })
      }
      



      //Add confidentiality agreement
      let confidentialityAgreement = new Image()
      //confidentialityAgreement.src = require('../assets/confidentiality_agreement.png')
      let confidentialityAgreementUrl = _global.serverSrc.slice(0,-4) + picSrc + 'confidentiality_agreement.png';
      confidentialityAgreement.src = confidentialityAgreementUrl
      PDF.addImage(confidentialityAgreement,'png',leftMargin,a4Height-60,a4Width-leftMargin-rightMargin,60) 
        //Add page number 
        PDF.setFontSize(10);
        let totalPage = PDF.internal.getNumberOfPages()
        for (let currentPage=1;currentPage<=totalPage-1;currentPage++){
          PDF.setPage(currentPage+1) // avoid cover page
          PDF.text(currentPage+'/'+Number(totalPage-1),a4Width-rightMargin,a4Height-60)
        }
      PDF.save(title+ reportDate_output_YYMMDD+'.pdf')
    
    }
  }
}
//reference:https://blog.csdn.net/pratise/article/details/79249943
//https://juejin.im/post/5b73d7a6518825610072b42b
